import { of, switchMap, tap, share, ReplaySubject, distinctUntilChanged, fromEvent, startWith, map, combineLatest, merge, first } from 'rxjs';

import { replaceViewContainer, renderTemplate } from './ui.js';
import { getCollectionMetadata, deleteCollection, truncateCollection } from './knowledge-api.js';
import { buildWorkMonitor } from './working.js';

export function createDestructCollectionView(colId) {
    return of(undefined).pipe(
        switchMap(() => {
            let root = renderTemplate('destruct-collection-view');
            replaceViewContainer(root);

            let actionMonitor = buildWorkMonitor();
            let saveIndicator$ = actionMonitor.showElements('.saving');
            let alertSavingBeforeUnload$ = actionMonitor.alertBeforeUnload();
            
            let meta$ = getCollectionMetadata(colId).pipe(
                first(),
                share({
                    connector: () => new ReplaySubject(1),
                    resetOnComplete: true,
                    resetOnError: true,
                    resetOnRefCountZero: true,
                }),
            );

            let renderMeta$ = meta$.pipe(
                tap(meta => {
                    root.querySelector('.collection-title').textContent = `${meta.owner}/${meta.name}`;
                    root.querySelector('.collection-name').textContent = meta.name;
                }),
            );

            let formDisabled$ = actionMonitor.working$;

            let userCollectionNameEl = root.querySelector('form input[name=collectionName]');
            let userCollectionName$ = fromEvent(userCollectionNameEl, 'input').pipe(
                startWith(undefined),
                map(() => userCollectionNameEl.value),
            );

            let formInputsDisabled$ = formDisabled$.pipe(
                tap(disabled => {
                    for (let el of root.querySelectorAll('form input')) {
                        el.disabled = disabled;
                    }
                }),
            );

            let enableActions$ = combineLatest([formDisabled$, meta$, userCollectionName$]).pipe(
                map(([formDisabled, meta, userCollectionName]) => formDisabled || (meta.name !== userCollectionName)),
                distinctUntilChanged(),
                tap(disabled => {
                    for (let btn of root.querySelectorAll('form button')) {
                        btn.disabled = disabled;
                    }
                }),
            );

            let removeAllDocuments$ = fromEvent(root.querySelector('.remove-all-documents'), 'click').pipe(
                switchMap(() => actionMonitor.zone(truncateCollection(colId))),
                tap(() => window.location.href = `#collection/${colId}`),
            );

            let deleteCollection$ = fromEvent(root.querySelector('.delete-collection'), 'click').pipe(
                switchMap(() => actionMonitor.zone(deleteCollection(colId))),
                tap(() => window.location.href = '#collections'),
            );
            
            return merge(
                saveIndicator$,
                alertSavingBeforeUnload$,
                renderMeta$,
                formInputsDisabled$,
                enableActions$,
                removeAllDocuments$,
                deleteCollection$,
            );
        }),
    );
}
